document.addEventListener('DOMContentLoaded', function () {
  const counters = document.querySelectorAll('.live-user-count');
  if (counters.length === 0) return;

  let min = parseInt(counters[0].getAttribute('data-min'), 10);
  let max = parseInt(counters[0].getAttribute('data-max'), 10);

  if (isNaN(min) || min < 1) min = 1;
  if (isNaN(max) || max < 1) max = 1;
  if (min > max) [min, max] = [max, min];

  // Start at a random value between min and max
  let currentValue = Math.floor(Math.random() * (max - min + 1)) + min;

  function updateCounters() {
    // Decide whether to increase or decrease by 2
    const direction = Math.random() < 0.5 ? -2 : 2;
    let newValue = currentValue + direction;

    // Clamp within min and max
    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;

    currentValue = newValue;

    counters.forEach(counter => {
      counter.textContent = currentValue;
    });
  }

  // Initial update
  counters.forEach(counter => {
    counter.textContent = currentValue;
  });

  // Update every 5 seconds
  setInterval(updateCounters, 5000);
});
